/* global attachEvent, localData, axios */

const wishlist = document.querySelector('.wishlist-module');
if (wishlist) {
  const removeFromWishlist = (item) => {
    item.closest('.product-card').classList.add('is-removed');
    if (wishlist.querySelectorAll('.product-card:not(.is-removed)').length === 0) {
      wishlist.classList.add('wishlist-module--empty');
      wishlist.querySelector('.wishlist-module__empty').classList.remove('hidden');
    }
  };

  wishlist.addEventListener('click', (e) => {
    const wishlistButton = e.target.closest('.wishlist-button');
    if (wishlistButton) {
      removeFromWishlist(wishlistButton);

      // Banner module wishlist counter
      const bannerModuleWishlist = document.querySelector('.banner-module--wishlist_counter');
      if (bannerModuleWishlist) {
        const text = bannerModuleWishlist.querySelector('.editor-text');
        if (text) {
          const wishlistNumber = wishlist.querySelectorAll('.product-card:not(.is-removed)').length;
          if (wishlistNumber === 0) {
            bannerModuleWishlist.style.display = 'none';
          } else if (wishlistNumber === 1) {
            text.innerHTML = `${wishlistNumber} ${bannerModuleWishlist.getAttribute('data-text-produ1')}`;
          } else if (wishlistNumber === 2) {
            text.innerHTML = `${wishlistNumber} ${bannerModuleWishlist.getAttribute('data-text-produ2')}`;
          } else if (wishlistNumber === 3 || wishlistNumber === 4) {
            text.innerHTML = `${wishlistNumber} ${bannerModuleWishlist.getAttribute('data-text-produ3')}`;
          } else {
            text.innerHTML = `${wishlistNumber} ${bannerModuleWishlist.getAttribute('data-text-produ4')}`;
          }
        }
      }
    }
  });

  // remove all items
  attachEvent('.wishlist-module__clear-btn', 'click', (ev) => {
    ev.preventDefault();
    const axiosData = new FormData();
    axiosData.append('action', 'removeAllItemsOnLikedList');
    axios
      .post(localData.apiURL, axiosData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        if (response.status === 200) {
          wishlist.classList.add('wishlist-module--empty');
          wishlist.querySelector('.wishlist-module__empty').classList.remove('hidden');
          const bannerModuleWishlist = document.querySelector('.banner-module--wishlist_counter');
          if (bannerModuleWishlist) {
            bannerModuleWishlist.style.display = 'none';
          }
          const numberInHeader = document.querySelectorAll('.header-main__heart .header-main__icon-items');
          numberInHeader.forEach((numberInHeader) => {
            numberInHeader.style.display = 'none';
          });
          document.querySelector('main').scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
  });
}
